import _styled from '@emotion/styled/base';
import { Flex } from '../../Flex/index.js';
import { VISUAL_ELEMENT_SIZE_MAP } from '../shared/constants.js';
import { border } from '@hubble/tokens/web';

const IconBadgeContainer = _styled(Flex, {
  target: "ev9rtuq0"
})("border-radius:", border.radius.full, ";width:", ({
  size
}) => VISUAL_ELEMENT_SIZE_MAP[size], ";min-width:", ({
  size
}) => VISUAL_ELEMENT_SIZE_MAP[size], ";height:", ({
  size
}) => VISUAL_ELEMENT_SIZE_MAP[size], ";justify-content:center;align-items:center;background-color:", ({
  backgroundColor
}) => backgroundColor, ";color:", ({
  color
}) => color, ";");

export { IconBadgeContainer };
